<template>
    <div class="header" :class="currentPath==='/home' && !showSubnavBg?'dark':'light'">
        <div class="nav_wrap">
            <img src="../assets/images/pd3.png" class="logo" v-if="currentPath==='/home' && !showSubnavBg"  @click="toHome">
            <img src="../assets/images/pd.png" class="logo" v-else  @click="toHome">
            <div class="navMenus" @mouseleave="showSubnavBg=false">
                <div class="nav"
                    :class="{'nav_active': currentPath===item.path, 'highlight': currentIndex==item.id}"
                    v-for="item in navList"
                    :key="item.id"
                    @mouseenter="enterNav(item)"
                    @mouseleave="currentIndex=-1"
                    @click="selectMenu(item.path)"
                >
                    <p class="name">{{item.name}}</p>

                    <div class="sub_nav_wrap" v-if="currentIndex==item.id && item.children && item.children.length>0">
                        <p class="sub_nav emphasis1"
                            :class="{'highlight': hoverSubnav===index || currentSubPath===c.path}"
                            v-for="(c,index) in item.children"
                            :key="c.path"
                            @mouseenter="hoverSubnav=index"
                            @mouseleave="hoverSubnav=-1"
                            @click.stop="selectMenu(c.path)"
                        >
                            {{c.name}}
                        </p>
                    </div>

                </div>
            </div>
        </div>
        <!-- <transition name="slide">
            <div class="sub_nav_bg" v-if="showSubnavBg" @mouseleave="showSubnavBg=false"></div>
        </transition> -->
        <div class="sub_nav_bg" :style="{height: subnavH + 'px'}" v-if="showSubnavBg"></div>
    </div>
</template>

<script>
import {NAV_DATA} from '../utils/hardData'

export default {
  name: 'VHeader',
  data () {
    return {
      navList: NAV_DATA,
      currentIndex: -1,
      hasChidren: false,
      hoverSubnav: -1,
      subnavH: 250,
      showSubnavBg: false
    }
  },
  created () {
    this.getCaseYearList()
  },
  methods: {
    getCaseYearList () {
      this.$get('/category/list').then(res => {
        if (res.errcode === 0) {
          let addPath = []
          res.content.data.forEach(c => {
            let path = { id: c, name: c + '年录取数据', path: '/results/record/' + c }
            addPath.push(path)
          })
          this.navList.forEach(item => {
            if (item.path === '/results') {
              // let children = item.children[0]
              let children = []
              item.children = [...children, ...addPath]
            }
          })
          this.subnavH = (addPath.length - 1) * 55 + 20 + 122
        }
      })
    },
    enterNav (item) {
      if (item.children && item.children.length > 0) {
        this.showSubnavBg = true
        this.currentIndex = item.id
      } else {
        this.showSubnavBg = false
        this.currentIndex = -1
      }
    },
    toHome () {
      this.$router.push({path: '/home'})
    },
    selectMenu (path) {
      this.$router.push({path})
    }
  },
  computed: {
    currentPath () {
      let route = this.$route
      let {meta, path} = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }

      // console.log(888,path)
      return path
    },
    currentSubPath () {
      let path = this.$route.path
      return path
    }
  }
}
</script>

<style lang="scss" scoped>
.light {
    background-color: #fff;
    color: #000;
    position: fixed;
    z-index: 99;
}
.dark {
    background-color: transparent;
    color: #fff;
    position: absolute;
}
.header {
    width: 100%;
    height: 122px;
    top: 0;
    z-index: 999;
    font-family: 'FZLTXIHJW';

    .nav_wrap {
        max-width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .logo {
            height: 60px;
            cursor: pointer;
        }
    }
    .navMenus {
        height: 100%;
        display: flex;
        align-items: center;
        .nav {
            height: 100%;
            padding: 0 15px;
            margin:  0 30px;
            font-size: 18px;
            cursor: pointer;
            border-bottom: 4px solid transparent;
            position: relative;
            &:last-child { margin-right: 0; }
            .name {
                height: 100%;
                padding-top: 36px;
                display: flex;
                align-items: center;
                font-family: 'FZCu_Yahei_Jian';
            }
        }
        .nav_active {
            background-color: #fff;
            color: #E77500;
            border-bottom: 4px solid rgba(#E77500, 1);
            .sub_nav_wrap {
                border-top: 4px solid rgba(#E77500, 1);
            }
        }
        .highlight { color: #E77500; }
        .sub_nav_wrap {
            width: 140px;
            padding: 8px 3px;
            background-color: rgba(#fff, 0.7);
            // box-shadow: 1px 1px 5px rgba(#000,0.1);
            border-top: 4px solid rgba(#E77500, 1);
            color: #363636;
            box-sizing: content-box;
            position: absolute;
            top: 118px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1000;

            .sub_nav {
                font-size: 16px;
                margin: 20px 0;
                cursor: pointer;
                font-weight: normal;
                text-align: center;
                font-family: 'FZCu_Yahei_Jian';
                // white-space: nowrap; // 不换行
                &:last-child {
                    margin-bottom: 5px;
                }
            }
        }
    }
    .sub_nav_bg {
        width: 100%;
        min-height: 250px;
        background-color: #fff;
        position: fixed;
        top: 0px;
        z-index: -1;
    }
    // .slide-enter-active, .slide-leave-active {
	//     transition: all 0s ease;
	// }
	// .slide-enter, .slide-leave-to{
	//     height: 0;
	// }

}

</style>



// WEBPACK FOOTER //
// src/components/header.vue